import type { ClientApplicationContext } from '@hc-frontend/core-context';
import { getClientApplicationConfig } from '@hc-frontend/core-context';

// Importar solo los adaptadores necesarios para el cliente
import { consoleAdapter } from '../../../adapters/console';
import { datadogBrowserLogAdapter } from '../../../adapters/datadog-browser-adapter';
import type { PerformSafeLogRepository } from '../../../domain';
import { logSimpleUC } from '../../../domain';

export function getClientLoggerFactory(): ClientApplicationContext['log'] {
  const config = getClientApplicationConfig();

  const adapter = datadogBrowserLogAdapter({
    clientToken: config.datadog.clientToken,
    env: config.core.appEnvironment,
    service: config.datadog.service,
    version: config.core.version,
  });

  const logger = consoleAdapter(config.core.appEnvironment);
  const wrapper: PerformSafeLogRepository = async (entry) => {
    void logger(entry);
    void adapter(entry);
  };

  return (log) =>
    logSimpleUC(
      {
        logger: wrapper,
      },
      log.type,
      log,
    );
}
